module.exports = __webpack_public_path__ + "img/11.784c8cef.png";